var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreaterSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8338 7.52249C8.83108 7.18493 8.69711 6.86151 8.46016 6.62092L2.22256 0.383313C1.97908 0.138752 1.64859 0.000967026 1.30358 0.000243187C0.958578 -0.000481606 0.627373 0.135851 0.382974 0.379145C0.138412 0.622621 0.000627518 0.953106 -9.63211e-05 1.29812C-0.00082016 1.64314 0.135511 1.97433 0.378805 2.21873L5.6984 7.53833L0.378805 12.8579V12.8581C0.0510292 13.1873 -0.0762386 13.6667 0.0450468 14.1152C0.166332 14.5639 0.517694 14.9138 0.966718 15.0331C1.41596 15.1523 1.89456 15.0229 2.22255 14.6935L8.46015 8.45589C8.70507 8.20734 8.83978 7.8707 8.83379 7.52188L8.8338 7.52249Z",
    fill: "#647CB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterSymbol);
export default __webpack_public_path__ + "static/media/greater__symbol.10d85446173da6287bc46312f0693039.svg";
export { ForwardRef as ReactComponent };